var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.464%",
    y1: "50%",
    x2: "61.367%",
    y2: "-7.527%",
    id: "account_svg__svg-374881278a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68616",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2A1E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.04 19.333c-.165-.042-1.332-.582-.624-2.791 1.875-1.958 3.333-5.083 3.333-8.168 0-4.749-3.167-7.249-6.832-7.249-3.667 0-6.833 2.5-6.833 7.25 0 3.125 1.459 6.25 3.334 8.207.75 1.958-.583 2.666-.876 2.792-3.833 1.375-8.376 3.916-8.376 6.416v.958c0 3.417 6.624 4.21 12.75 4.21 6.125 0 12.667-.792 12.667-4.21v-.958c.042-2.582-4.5-5.124-8.542-6.457h0z",
    stroke: "#00264F",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.04 18.333c-.165-.042-1.332-.582-.624-2.791 1.875-1.958 3.333-5.083 3.333-8.168 0-4.749-3.167-7.249-6.832-7.249-3.667 0-6.833 2.5-6.833 7.25 0 3.124 1.459 6.25 3.334 8.207.75 1.958-.583 2.666-.876 2.792C4.709 19.749.166 22.29.166 24.79v.958c0 3.417 6.624 4.21 12.75 4.21 6.125 0 12.667-.792 12.667-4.21v-.958c.042-2.582-4.5-5.124-8.542-6.457h0z",
    stroke: "url(#account_svg__svg-374881278a)",
    opacity: 0,
    transform: "translate(1 1)"
  }))));
}

export default SvgAccount;